/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import './TestCard.scss';

const TestCard = ({ testDetails, removeItem }) => {
  const removeTest = () => {
    if (confirm('Are you sure you want to remove this test ?')) {
      const { item_id, item_type } = testDetails;
      removeItem(item_id, item_type);
    }
  };

  return (
    <div className="mainContainerX" key={testDetails.item_id}>
      <div className="imgContainerTest">
        <img src={require('../../images/labtest.svg')} alt="x" />
      </div>
      <div className="textContainer">
        <div className="textTitle">{testDetails.item_name}</div>
        <div className="textSubtitleTest"><img src={require('../../images/time.svg')} alt="x" />{testDetails.tat_text}</div>
        {!testDetails.is_live && <div className="error">Test unavailable. Please choose another lab.</div>}
      </div>
      <div className="priceContainer">
        <div className="mrPrice">&#8377;{testDetails.mrp}</div>
        <div className="pePrice">&#8377;{testDetails.pe_selling_price}</div>
      </div>
      <div className="deleteContainer" onClick={removeTest}>
        <img src={require('../../images/remove.svg')} alt="x" />
      </div>
    </div>
  );
};

TestCard.propTypes = {
  testDetails: PropTypes.object.isRequired,
  removeItem: PropTypes.func.isRequired,
};

export default TestCard;
